import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton TanStack Query client.
 *
 * Defaults follow the project-wide convention: `staleTime: 30s` so navigation
 * doesn't re-fetch the same data within a session, but writes / mutations
 * always re-fetch via explicit `invalidateQueries`. `refetchOnWindowFocus` is
 * disabled because the app tab can be in the background for hours; we
 * rely on TanStack's `refetchOnReconnect` + manual invalidation instead.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on auth failures — bubble up to the route boundary.
        const status = (error as { status?: number } | null)?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
